import {
  storeInLocalStorage,
  getFromLocalStorage,
  removeFromLocalStorage,
  clearAllLocalStorage
} from "../Components/WebChat/WebChatEncryptDecrypt";

// Action Types
export const AUTH_ACTIONS = {
  SET_AUTH_USER: "SET_AUTH_USER",
  LOGOUT: "LOGOUT",
  UPDATE_USER_PROFILE: "UPDATE_USER_PROFILE"
};

// Initial State
const initialState = {
  isAuthenticated: !!getFromLocalStorage("token"),
  user: null,
  token: getFromLocalStorage("token"),
  loading: false,
  error: null
};

// Auth Reducer
export const AuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case AUTH_ACTIONS.SET_AUTH_USER:
      // Store token and user in localStorage
      storeInLocalStorage("token", action.payload.token);

      return {
        ...state,
        isAuthenticated: true,
        user: action.payload.user,
        token: action.payload.token,
        loading: false,
        error: null
      };

    case AUTH_ACTIONS.UPDATE_USER_PROFILE:
      return {
        ...state,
        user: {
          ...state.user,
          ...action.payload
        }
      };

    case AUTH_ACTIONS.LOGOUT:
      // Remove token and user from localStorage
      removeFromLocalStorage("token");
      // on logout remove everything fromlocal storage
      clearAllLocalStorage();

      return {
        ...initialState,
        isAuthenticated: false,
        user: null,
        token: null
      };

    default:
      return state;
  }
};

// Action Creators
export const setAuthUser = (userData) => ({
  type: AUTH_ACTIONS.SET_AUTH_USER,
  payload: userData
});

export const updateUserProfile = (profileData) => {
  return {
    type: AUTH_ACTIONS.UPDATE_USER_PROFILE,
    payload: profileData
  };
};

export const logoutUser = () => ({
  type: AUTH_ACTIONS.LOGOUT
});

export default AuthReducer;
